module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="modal fade bs-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">\n    <div class="modal-dialog modal-sm">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title">' +
((__t = (terms.renameWorkbench[language])) == null ? '' : __t) +
'</h4>\n            </div>\n            <div class="modal-body">\n                <input id="renameWorkbenchInput" type="text" placeholder="' +
((__t = (terms.renameTo[language])) == null ? '' : __t) +
'" class="form-control" style="margin-bottom: 10px">\n                <button type="button" id="renameWorkbenchButton" class="btn">' +
((__t = (terms.rename[language])) == null ? '' : __t) +
'</button>\n            </div>\n        </div>\n    </div>\n</div>';

}
return __p
}